<template>
  <v-timeline align="start" dense side="end" class="pa-6">
    <v-timeline-item
      v-for="(event, index) in plan"
      :id="`dot-${index}`"
      :key="event.code1C"
      :dot-color="dotColor(event.dateFrom, event.dateTo)"
    >
      <template #opposite>
        <div class="text-right text-caption">
          <div>{{ formatDate(event.dateFrom) }}<br />{{ formatDate(event.dateTo) }}</div>
          <i>{{ relativeDate(event.dateFrom, event.dateTo) }}</i>
        </div>
      </template>
      <template #default>
        <div>
          <div class="font-weight-bold text-subtitle-2">{{ event.name }}</div>
          <div class="text-subtitle-2">{{ event.description }}</div>
        </div>
      </template>
    </v-timeline-item>
  </v-timeline>
</template>

<script setup>
import moment from 'moment'
moment.locale('ru')

defineProps({
  plan: {
    type: Array,
    default: () => [],
  },
})

const relativeDate = (fromDt, tillDt) => {
  const from = moment(fromDt)
  const till = moment(tillDt)

  switch (getDateStatus(fromDt, tillDt)) {
    case 'past':
      return `прошло ${till.toNow(true)} назад`
    case 'future':
      return `начнется через ${from.fromNow(true)}`
    case 'active':
      return `осталось ${till.toNow(true)}`
  }
}

const dotColor = (fromDt, tillDt) => {
  switch (getDateStatus(fromDt, tillDt)) {
    case 'past':
      return 'grey'
    case 'future':
      return 'green'
    case 'active':
      return 'primary'
  }
}

const getDateStatus = (fromDt, tillDt, now = moment()) => {
  const from = moment(fromDt)
  const till = moment(tillDt)

  if (till.isBefore(now)) return 'past'
  if (from.isAfter(now)) return 'future'
  return 'active'
}

const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
</script>

<style lang="scss">
</style>
